// Theme sandbox: removed together with the switcher at release time.
// The theme list is duplicated in the inline script in panel_base.html — that
// script must be self-contained to run before the bundle loads.
const STORAGE_KEY = 'pva_theme';

function applyTheme(theme) {
    document.documentElement.setAttribute('data-bs-theme', theme);
}

export function setupThemeSwitcher() {
    document.querySelectorAll('[data-pva-theme]').forEach((el) => {
        el.addEventListener('click', () => {
            const theme = el.dataset.pvaTheme;
            try {
                localStorage.setItem(STORAGE_KEY, theme);
            } catch (e) {
                console.warn('pva: theme applied but not persisted (localStorage unavailable)');
            }
            applyTheme(theme);
        });
    });
}